import React from "react";
import { Link } from "react-router-dom";
import Logo from "./../../assets/logo.png";
import { MdKeyboardArrowRight } from "react-icons/md";
import Image from "./../../assets/blog_image_1-375x211.jpg";
import { FaFacebookF, FaGooglePlusG, FaInstagram, FaTelegramPlane, FaTwitter } from "react-icons/fa";

const Footer = () => {
  return (
    <div className="bg-black">
      <div className="flex flex-wrap gap-4 p-4 py-12 text-white">
        <div className="flex-1 min-w-[250px] flex flex-col gap-10">
          <div>
            <img
              src={Logo}
              alt=""
              className="w-full max-w-[200px] rounded-xl"
            />
          </div>
          <p className="font-rubik text-[12px] text-[#8f989f]">
            Condimentum adipiscing vel neque dis nam parturient orci at
            scelerisque neque dis nam parturient.
          </p>
          <p className="font-rubik text-[13px] max-w-[170px] text-[#8f989f]">
            451 Wall Street, UK, London Phone: (064) 332-1233 Fax: (099)
            453-1357
          </p>
        </div>
        <div className="flex-1 min-w-[250px]">
          <p className="font-rubik text-white font-bold text-xl">Blog</p>

          <div className="flex items-start gap-2 mt-6">
            <div className="">
              <img src={Image} alt="" className="min-w-[60px] h-[60px]" />
            </div>
            <div>
              <p className="font-rubik font-bold hover:text-primary text-[14px]">
                At Solmen va Essern Neceasi the Angleso Grammatica
              </p>
              <div className="flex items-center gap-2 my-1 text-[12px]">
                <p className="font-rubik text-[12px] font-normal text-[#b0b8bf]">
                  February 15, 2023
                </p>
              </div>
            </div>
          </div>

          <div className="flex items-start gap-2 mt-4">
            <div className="">
              <img src={Image} alt="" className="min-w-[60px] h-[60px]" />
            </div>
            <div>
              <p className="font-rubik font-bold hover:text-primary text-[14px]">
                At Solmen va Essern Neceasi the Angleso Grammatica
              </p>
              <div className="flex items-center gap-2 my-1 text-[12px]">
                <p className="font-rubik text-[12px] font-normal text-[#b0b8bf]">
                  February 15, 2023
                </p>
              </div>
            </div>
          </div>
        </div>
        <div className="flex-1 min-w-[250px]">
          <p className="font-rubik text-white font-bold text-xl">
            Product Tags
          </p>
          <div className="flex flex-wrap gap-2 mt-6">
            <div className="bg-[#ffffff2e] px-2 p-1 text-[13px] rounded-full font-rubik text-[#8f989f]">
              Action
            </div>
            <div className="bg-[#ffffff2e] px-2 p-1 text-[13px] rounded-full font-rubik text-[#8f989f]">
              Adventure
            </div>
            <div className="bg-[#ffffff2e] px-2 p-1 text-[13px] rounded-full font-rubik text-[#8f989f]">
              Battle Royale
            </div>
            <div className="bg-[#ffffff2e] px-2 p-1 text-[13px] rounded-full font-rubik text-[#8f989f]">
              Coop
            </div>
            <div className="bg-[#ffffff2e] px-2 p-1 text-[13px] rounded-full font-rubik text-[#8f989f]">
              Fighting game
            </div>
            <div className="bg-[#ffffff2e] px-2 p-1 text-[13px] rounded-full font-rubik text-[#8f989f]">
              Gamepass
            </div>
            <div className="bg-[#ffffff2e] px-2 p-1 text-[13px] rounded-full font-rubik text-[#8f989f]">
              PC
            </div>
            <div className="bg-[#ffffff2e] px-2 p-1 text-[13px] rounded-full font-rubik text-[#8f989f]">
              PS5
            </div>
            <div className="bg-[#ffffff2e] px-2 p-1 text-[13px] rounded-full font-rubik text-[#8f989f]">
              Rally
            </div>
            <div className="bg-[#ffffff2e] px-2 p-1 text-[13px] rounded-full font-rubik text-[#8f989f]">
              Remake
            </div>
            <div className="bg-[#ffffff2e] px-2 p-1 text-[13px] rounded-full font-rubik text-[#8f989f]">
              Role Playing
            </div>
            <div className="bg-[#ffffff2e] px-2 p-1 text-[13px] rounded-full font-rubik text-[#8f989f]">
              Shooter
            </div>
            <div className="bg-[#ffffff2e] px-2 p-1 text-[13px] rounded-full font-rubik text-[#8f989f]">
              Sport
            </div>
          </div>
        </div>
        <div className="flex-1 min-w-[250px]">
          <p className="font-rubik text-white font-bold text-xl">Categories</p>
          <ul className="mt-6">
            <li className="mb-3 flex items-center">
              <MdKeyboardArrowRight size={24} />
              <Link to="/games">Games</Link>
            </li>
            <li className="mb-3 flex items-center">
              <MdKeyboardArrowRight size={24} />
              <Link to="/playstation">Playstation</Link>
            </li>
            <li className="mb-3 flex items-center">
              <MdKeyboardArrowRight size={24} />
              <Link to="/pc">PC</Link>
            </li>
            <li className="mb-3 flex items-center">
              <MdKeyboardArrowRight size={24} />
              <Link to="/xbox">Xbox</Link>
            </li>
            <li className="mb-3 flex items-center">
              <MdKeyboardArrowRight size={24} />
              <Link to="/featured">Featured</Link>
            </li>
          </ul>
        </div>
        <div className="flex-1 min-w-[250px]">
          <p className="font-rubik text-white font-bold text-xl">Information</p>
          <ul className="mt-6">
            <li className="mb-3 flex items-center">
              <MdKeyboardArrowRight size={24} />
              <Link to="/">Homepage</Link>
            </li>
            <li className="mb-3 flex items-center">
              <MdKeyboardArrowRight size={24} />
              <Link to="/news">News</Link>
            </li>
            <li className="mb-3 flex items-center">
              <MdKeyboardArrowRight size={24} />
              <Link to="/shop">Shop</Link>
            </li>
            <li className="mb-3 flex items-center">
              <MdKeyboardArrowRight size={24} />
              <Link to="/about-us">About Us</Link>
            </li>
            <li className="mb-3 flex items-center">
              <MdKeyboardArrowRight size={24} />
              <Link to="/contact-us">Contact Us</Link>
            </li>
            <li className="mb-3 flex items-center">
              <MdKeyboardArrowRight size={24} />
              <Link to="/faqs">FAQs</Link>
            </li>
          </ul>
        </div>
      </div>

      <div className="p-4 py-8 bg-[#0b141c] border-t-[#20282f] flex flex-wrap items-center justify-between gap-4">
        <p className="font-rubik text-white">
          © CopyRight 2023 | template designed by Hex Wp - All lefts reserved |
          Designed for WordPress
        </p>

        <ul className="flex items-center justify-center gap-5">
          <li className="bg-[#395498] hover:bg-primary text-white cursor-pointer w-10 h-10 flex justify-center items-center rounded-full text-xl">
            <FaFacebookF />
          </li>
          <li className="bg-[#5da9dd] hover:bg-primary text-white cursor-pointer w-10 h-10 flex justify-center items-center rounded-full text-xl">
            <FaTwitter/>
          </li>
          <li className="bg-[#d54c40] hover:bg-primary text-white cursor-pointer w-10 h-10 flex justify-center items-center rounded-full text-xl">
            <FaGooglePlusG />
          </li>
          <li className="bg-[#29a1d5] hover:bg-primary text-white cursor-pointer w-10 h-10 flex justify-center items-center rounded-full text-xl">
            <FaTelegramPlane />
          </li>
          <li className="bg-[#00afc0] hover:bg-primary text-white cursor-pointer w-10 h-10 flex justify-center items-center rounded-full text-xl">
            <FaInstagram />
          </li>
        </ul>
      </div>
    </div>
  );
};

export default Footer;
